import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_tk5zqjo',     // ✅ replace with your actual service ID
      'template_r81rr53',    // ✅ replace with your actual template ID
      form.current,
      'bP79j8Y-gS9V79CJ0'    // ✅ replace with your actual public key
    ).then(() => {
      setStatus('✅ Message sent successfully!');
      form.current.reset();
    }).catch((error) => {
      console.error(error);
      setStatus('❌ Failed to send. Please try again.');
    });
  };

  return (
    <div className="contact-form">
      <h2>Send a Message</h2>
      <form ref={form} onSubmit={sendEmail}>
        <div className="input-group">
          <i className="fas fa-user"></i>
          <input type="text" name="user_name" placeholder="Your Name" required />
        </div>
        <div className="input-group">
          <i className="fas fa-envelope"></i>
          <input type="email" name="user_email" placeholder="Your Email" required />
        </div>
        <div className="input-group">
          <i className="fas fa-tag"></i>
          <input type="text" name="subject" placeholder="Subject" required />
        </div>
        <div className="input-group">
          <i className="fas fa-comment-alt"></i>
          <textarea name="message" placeholder="Your Message" rows="5" required />
        </div>
        <button type="submit">
          <i className="fas fa-paper-plane"></i> Send Message
        </button>
        {status && <p className="form-status">{status}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
